import { client } from '..';
import { SalaryParams } from '../models/salariesModels';

export const createSalary = async ({
  nonProfitOrgId,
  fullName,
  position,
  annualSalary,
  allowance
}: SalaryParams): Promise<any> => {
  const { data } = await client.post('/salaries', {
    fullName,
    position,
    annualSalary,
    allowance,
    nonProfitOrgId
  });
  return data;
};

export const createManySalaries = async (body: { salaries: SalaryParams[]; npoId?: string }): Promise<any> => {
  const parsedNonProfitOrgId = body.npoId ? `?npoId=${body.npoId}` : '';

  const { data } = await client.post(`/salaries/replace${parsedNonProfitOrgId}`, { salaries: body.salaries });
  return data;
};
